import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ToastController } from '@ionic/angular';

import { IonicAlertsOutletComponent } from './ionic-alerts-outlet.component';
import { AngularAlertsOutletComponent } from './angular-alerts-outlet.component';
import { AlertsService } from './alerts.service';

// Factory function to preload ToastController
export function preloadToastController(toastController: ToastController): () => Promise<void> {
  return async () => {
    const toast = await toastController.create({
      message: '',
      duration: 1,
    });
    await toast.dismiss();
  };
}

@NgModule({
  declarations: [
    IonicAlertsOutletComponent,
    AngularAlertsOutletComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [
    IonicAlertsOutletComponent,
    AngularAlertsOutletComponent,
  ],
  providers: [
    ToastController,
    {
      provide: APP_INITIALIZER,
      useFactory: preloadToastController,
      deps: [ToastController],
      multi: true,
    },
  ],
})
export class AlertsModule {
  static forRoot(): ModuleWithProviders<AlertsModule> {
    return {
      ngModule: AlertsModule,
      providers: [AlertsService],
    };
  }
}
